module.exports = __webpack_public_path__ + "img/purple.ebe70539.svg";